import React from 'react';

import {
  Grid,
} from '@mui/material';

import { Course } from '../../../../services/courses/types';
import { Metadata } from '../../../../services/types';

import CourseDetailsCard from './CourseDetailsCard';
import StreamsCard from './StreamsCard';

interface DetailsTabProps {
  course?: Course,
  courseMetadata?: Metadata,
}

const DetailsTab = ({ course, courseMetadata }: DetailsTabProps) => (
  <Grid container spacing={2}>
    <Grid item xs={12}>
      <CourseDetailsCard course={course} metadata={courseMetadata} />
    </Grid>
    <Grid item xs={12}>
      <StreamsCard course={course} />
    </Grid>
  </Grid>
);

export default DetailsTab;
